import React, { useRef, useState }  from 'react';
import ReactDOM from 'react-dom';
import "core-js/stable";

import {
    CartDetailsView,
    CheckoutView,
    CheckoutProvider,
    SidebarCartView,
    RouteNames,
    ToolsPage
} from '@ttg/ui-checkout-lib';
import 'tailwindcss/tailwind.css';
import '@ttg/ui-checkout-lib/index.css';

function onCheckoutClick() {
    window.location.href = '/checkout-view';
}

function onViewCartClick() {
    window.location.href = `/shopping-cart-view`;
}

function onContinueShopping() {
    window.location.href = '/store';
}

function onAddClick() {
    window.location.href = `/shopping-cart-view`;
}

//Sidebar cart component
function CustomCartSidebarComponent({ renderMobileView = false }) {

    const [data] = useState({
        user: object.user || undefined,
        apiUrl: object.apiUrl || '',
        captchaSiteKey: object.captchaSiteKey || ''
    });

    const sidebarCartRef = useRef(null);

    function addProductToCart(stripeProductId) {
        window.gtag('event', 'conversion', {'send_to': 'AW-1042091124/AhoiCMG68JEYEPSY9PAD'});
        const item = sidebarCartRef.current.onAddPreviewItem(stripeProductId);
    }

    function shouldOpenSidebar() {
        if (window.location.href.includes(RouteNames.cartDetails) || window.location.href.includes(RouteNames.checkout) || checkIsMobileScreen())
            return false;
        return true;
    }

    window.addProductToCart = addProductToCart;

    return (<CheckoutProvider
        applicationId={'TTG'}
        apiEndpoint={data.apiUrl}
        captchaSiteKey={data.captchaSiteKey}
        captchaEnabled={true}
    >
        <SidebarCartView
            ref={sidebarCartRef}
            userId={data?.user?.id || undefined}
            onCheckoutClick={onCheckoutClick}
            onViewCartClick={onViewCartClick}
            onContinueShopping={onContinueShopping}
            onOpenClick={!shouldOpenSidebar() ? onViewCartClick : undefined}
        />
    </CheckoutProvider>);
}

function renderCartSidebarComponent(){

    const sidebarCartComponent = document.getElementById('sidebar-cart-view-component');
    const sidebarMobileCartComponent = document.getElementById('mobile-sidebar-cart-view-component');

    if (sidebarCartComponent || sidebarMobileCartComponent) {
        if(checkIsMobileScreen()){
            ReactDOM.render(
                <></>,
                sidebarCartComponent
            );
            ReactDOM.render(
                <CustomCartSidebarComponent />,
                sidebarMobileCartComponent
            );
        }
        else{
            ReactDOM.render(
                <CustomCartSidebarComponent />,
                sidebarCartComponent
            );
            ReactDOM.render(
                <></>,
                sidebarMobileCartComponent
            );
        }
    }
}
document.addEventListener('DOMContentLoaded', renderCartSidebarComponent);

//Cart Details component
function CustomCartDetailsComponent() {
    const [data] = useState({
        user: object.user || undefined,
        apiUrl: object.apiUrl || '',
        captchaSiteKey: object.captchaSiteKey || ''
    });

    return (
        <CheckoutProvider
            applicationId={'TTG'}
            apiEndpoint={data.apiUrl}
            captchaSiteKey={data.captchaSiteKey}
            captchaEnabled={true}
        >
            <CartDetailsView
                userId={data?.user?.id || undefined}
                onCheckoutClick={onCheckoutClick}
                onContinueShopping={onContinueShopping}
            />
        </CheckoutProvider>
    );
}

function renderCartDetails() {

    const element = document.getElementById('cart-details-component');

    if (element) {

        ReactDOM.render(
            <CustomCartDetailsComponent />,
            element
        );
    }
}
document.addEventListener('DOMContentLoaded', renderCartDetails);

//Checkout componnet
function CustomCheckoutComponent() {
    const [data] = useState({
        user: object.user || undefined,
        apiUrl: object.apiUrl || '',
        stripeKey: object.stripeKey,
        captchaSiteKey: object.captchaSiteKey || ''
    });

    function checkIfHasCartItems() {
        const keyXApplication = `usersCart-TTG`;
        const cartDetails = localStorage.getItem(keyXApplication);
        if (!cartDetails) return false;
        const cartObject = JSON.parse(cartDetails)?.[data?.user?.id];

        return (
                cartObject &&
                cartObject?.cartItems.length > 0 &&
                !cartObject?.cartItems.find((item) => item?.type === 'certification' && !item?.yourWorkingGeniuses)
        );
    }

    if ((location.pathname === '/checkout-view/' || location.pathname === '/checkout-view') && !checkIfHasCartItems()) {
        window.location.href = '/shopping-cart-view';
        return null;
    }

    function onEditCard() {
        window.location.href = '/shopping-cart-view';
    }

    function onCompleteOrder(currentInvoice) {
        window.gtag('event', 'conversion', {
            'send_to': 'AW-1042091124/3Y9mCL668JEYEPSY9PAD',
            'value': (currentInvoice?.total || 0) / 100,
            'currency': 'USD',
            'transaction_id': currentInvoice?.id || ''
        });
    }

    return (
        <CheckoutProvider
            applicationId={'TTG'}
            apiEndpoint={data.apiUrl}
            captchaSiteKey={data.captchaSiteKey}
            captchaEnabled={true}
        >
            <CheckoutView stripeKey={data.stripeKey} onEditCard={onEditCard} user={data.user} onCompleteOrder={onCompleteOrder}/>
        </CheckoutProvider>
    );
}

function renderCheckoutDetails() {

    const element = document.getElementById('checkout-details-component');

    if (element) {

        ReactDOM.render(
            <CustomCheckoutComponent />,
            element
        );
    }
}
document.addEventListener('DOMContentLoaded', renderCheckoutDetails);

function checkIsMobileScreen() {
    return window.innerWidth < 991;
}

checkIsMobileScreen();

window.addEventListener('resize', renderCartSidebarComponent);

function ToolsPageRenderer() {
    Cookies.set('checkout_application_id', 'TTG', { expires: 7 });

    const [data] = useState({
        user: object.user || undefined,
        ttgBaseUrl: object.ttgBaseUrl || '',
        wgBaseUrl: object.wgBaseUrl || '',
    });

    return (
        <ToolsPage
            type={'ttg'}
            ttgBaseUrl={data.ttgBaseUrl}
            wgBaseUrl={data.wgBaseUrl}
            wgCertification={data?.user?.wgCertificationStatus.status_id}
            showCapaPro={data?.user?.showCapaPro || false}
            hasTeamApplicationGuide={data?.user?.hasTeamApplicationGuide || false}
            showAssessment={data?.user?.showAssessment || false}
            showMeetingAdvantage={data?.user?.showMeetingAdvantage || false}
            showVideos={data?.user?.showVideos || false}
            isRegisteredInAlumniIntensives={data?.user?.isRegisteredInAlumniIntensives}
        />
    );
}

function renderToolsPageContent() {
    const element = document.getElementById('tools-page-content-v3');
    if (element) {
        ReactDOM.render(
            <ToolsPageRenderer />,
            element
        );
    }
}

document.addEventListener('DOMContentLoaded', renderToolsPageContent);
